import { render, staticRenderFns } from "./Machine.vue?vue&type=template&id=545d0326&scoped=true&"
import script from "./Machine.vue?vue&type=script&lang=js&"
export * from "./Machine.vue?vue&type=script&lang=js&"
import style0 from "./Machine.vue?vue&type=style&index=0&id=545d0326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d0326",
  null
  
)

component.options.__file = "Machine.vue"
export default component.exports